import { Event, Id, Identifiable, List, Milestone, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

const ENDPOINTS = {
  TASK: "/tasks/",
  LIST: "/activities/",
  EVENT: "/events/",
  MILESTONE: "/milestones/",
  EXPENSE: "/expenses/",
};

type Element = Identifiable<Task | List | Event | Milestone>;

function removeAttachedDocument(httpClient: HttpClient) {
  return (
    elementType: "TASK" | "LIST" | "EVENT" | "MILESTONE" | "EXPENSE",
    elementId: Id,
    documentId: Id,
  ) => {
    const endpoint = `${ENDPOINTS[elementType]}${elementId}`;
    return httpClient
      .sendHttpRequest<Element>({
        endpoint,
        method: HttpMethods.GET,
      })
      .then((el) => {
        const attachment = (el.attachments || []).find(
          (att) => att.attachedEntityUuid === documentId,
        );
        if (!attachment) {
          throw new Error("Error - no attachment found");
        }
        return httpClient.sendHttpRequest<void>({
          endpoint: `/attachments/${attachment.uuid}`,
          method: HttpMethods.DELETE,
        });
      })
      .then(() =>
        Promise.resolve({
          elementType,
          elementId,
          documentId,
        }),
      );
  };
}

export { removeAttachedDocument };
